import { createAsyncThunk } from "@reduxjs/toolkit";
import ProductApiService from "../apiServices/ProductApiService";
import { ProductDetailsModal } from "../../interfaces/ProductObject";

export const fetchCartProducts = createAsyncThunk(
  "cart/fetchCartProducts",
  async (productIds: string[], { rejectWithValue }) => {
    try {
      const response: any = await ProductApiService.getProductsByIds(productIds);
      const products: ProductDetailsModal[] = response.contents[0].products ?? [];
      return products;
    } catch (e) {
      return rejectWithValue("Failed to load cart products");
    }
  }
);

const CartThunk = { fetchCartProducts };

export default CartThunk;
